
import {ContextProvider} from "context/Context";
import Modal from 'components/modal/portal'
import Routes from "routes";
import useCompanySwitchReload from "hooks/useCompanySwitchReload";
import 'styles/main.scss'

function App() {
  useCompanySwitchReload()

  return (
      <ContextProvider>
        <Modal/>
        <Routes/>
      </ContextProvider>
  );
}

export default App;
